/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBrokenImage = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M1.293 2.707 2 3.414V22h18.586l.707.707 1.414-1.414-20-20-1.414 1.414zm11.856 11.857L12 16l-3-5-4 8h12.586l1 1H4V5.414l9.15 9.15zM20 15.757V4H8.243l-2-2H22v15.757l-2-2zM18 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBrokenImage as BrokenImage };
